$(document).ready(function () {
    $('.section-vaad-faq .faq-answer').hide();
    $('.section-vaad-faq .faq-item').removeClass('active');
    $('.section-vaad-faq .faq-question').attr('aria-expanded', 'false');

    $('.section-vaad-faq .faq-question').on('click', function () {
        let $currentItem = $(this).closest('.faq-item');
        let $currentAnswer = $currentItem.find('.faq-answer');

        if ($currentItem.hasClass('active')) {
            $currentItem.removeClass('active');
            $(this).attr('aria-expanded', 'false');
            $currentAnswer.stop(true, true).slideUp(300);
        } else {
            $('.section-vaad-faq .faq-item').removeClass('active');
            $('.section-vaad-faq .faq-question').attr('aria-expanded', 'false');
            $('.section-vaad-faq .faq-answer').stop(true, true).slideUp(300);

            $currentItem.addClass('active');
            $(this).attr('aria-expanded', 'true');
            $currentAnswer.stop(true, true).slideDown(300);
        }
    });
});